export type ReviewKeyAction = 'next' | 'previous' | 'use' | 'keep';

const TYPING_SELECTOR = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';

export function isTypingTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(TYPING_SELECTOR) !== null;
}

const ACTIONS: Record<string, ReviewKeyAction> = {
  j: 'next',
  k: 'previous',
  u: 'use',
  c: 'keep',
};

export function reviewKeyAction(event: {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
  repeat: boolean;
  target: EventTarget | null;
  defaultPrevented: boolean;
}): ReviewKeyAction | null {
  if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return null;
  if (event.repeat || event.defaultPrevented || isTypingTarget(event.target)) return null;
  return ACTIONS[event.key.toLowerCase()] ?? null;
}
